import React from 'react';
import { packItems } from '../data/content';
export function WhatsInside() {
  return <section id="inside" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-228" data-mp="yvr11dwvo5qs">
      <div className="mx-auto max-w-4xl" data-id="element-229" data-mp="yto8on8960iw">
        <h2 className="text-center font-serif text-[1.6rem] font-black leading-tight tracking-tight text-stone-900 sm:text-4xl" data-id="element-230" data-mp="kx13xya2662f">
          <span aria-hidden="true" data-id="element-231" data-mp="ptrigh67stlq">📦 </span>¿Qué Hay Dentro del Pack INGLÉS
          LISTO™?
        </h2>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-232" data-mp="b552cd8rjxtg">
          {packItems.map(item => <li key={item.title} className="rounded-2xl bg-stone-100 px-6 py-8 text-center" data-id="element-233" data-mp="fyzij6p5tuns">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-234" data-mp="74betkz8gl13">
                {item.emoji}
              </span>
              <h3 className="mt-4 font-serif text-base font-bold text-stone-900" data-id="element-235" data-mp="3oe9fy1i3ubp8">
                {item.title}
              </h3>
              <p className="mt-2 text-xs leading-relaxed text-stone-500" data-id="element-236" data-mp="3te5kc1ups55b">
                {item.text}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}